import {
  anUpdateRuleTuningExpression,
  mockUpdateRuleTuningExpressionOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockUpdateRuleTuningExpressionOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          updateRuleTuningExpression: anUpdateRuleTuningExpression(),
        },
      });
    }
  ),
];
